module.exports = __webpack_public_path__ + "img/SUMMIT.4d5b2bd2.jpg";